import {loadScript} from '../utility';

/**
 * Makes a JSONP Get request.
 * @param {string} url   
 * @param {string} callback 
 */
export function performJsonpGetRequest(url, callbackName) {
    if(url){
        let finalUrl = `${url}&callback=novSelect.${callbackName}`;
        loadScript(finalUrl);
    }
}


// WEBPACK FOOTER //
// ./src/lib/HttpRequest.js